import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { toast } from 'react-toastify';
import { listarDepartamentos, criarAssuntoFaq } from '~/Services/Service';

const ModalCadastroAssunto = ({ show, onHide, onSucesso, departamentoUsuario }) => {
  const [departamentoOptions, setDepartamentoOptions] = useState([]);
  const [departamento, setDepartamento] = useState(null);
  const [nomeAssunto, setNomeAssunto] = useState('');
  const [errors, setErrors] = useState({});
  const [salvando, setSalvando] = useState(false);

  useEffect(function() {
    listarDepartamentos().then(function(res) {
      var deptos = res || [];
      var opcoes = deptos.map(function(d) {
        return { value: d.codigo, label: d.descricao };
      });
      setDepartamentoOptions(opcoes);

      if (departamentoUsuario) {
        var deptoUsuario = opcoes.find(function(d) { return d.value === departamentoUsuario; });
        if (deptoUsuario) setDepartamento(deptoUsuario);
      }
    }).catch(function() { /* ignore */ });
  }, [show]);

  var validar = function() {
    var errs = {};
    if (!departamento) errs.departamento = 'Departamento é obrigatório';
    if (!nomeAssunto.trim()) errs.nomeAssunto = 'Nome do assunto é obrigatório';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  var handleSalvar = function() {
    if (!validar()) {
      toast.error('Preencha todos os campos obrigatórios');
      return;
    }
    setSalvando(true);
    criarAssuntoFaq({
      codigo_departamento: departamento.value,
      nome: nomeAssunto.trim(),
    })
      .then(function() {
        toast.success('Assunto cadastrado com sucesso!');
        if (onSucesso) onSucesso();
        handleClose();
      })
      .catch(function(err) {
        var msg = err && err.response && err.response.data && err.response.data.mensagem
          ? err.response.data.mensagem
          : 'Erro ao cadastrar assunto. Tente novamente.';
        toast.error(msg);
      })
      .finally(function() {
        setSalvando(false);
      });
  };

  var handleLimpar = function() {
    setDepartamento(null);
    setNomeAssunto('');
    setErrors({});
  };

  var handleClose = function() {
    handleLimpar();
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cadastrar Assunto</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Departamento <span className="text-danger">*</span></Form.Label>
            <Select
              placeholder="Selecione..."
              options={departamentoOptions}
              value={departamento}
              onChange={function(val) { setDepartamento(val); setErrors(function(prev) { var e = Object.assign({}, prev); delete e.departamento; return e; }); }}
              styles={errors.departamento ? { ...customStyles, control: function(base) { return Object.assign({}, base, { padding: '2px', borderRadius: '6px', borderColor: '#dc3545' }); } } : customStyles}
              components={{ DropdownIndicator }}
              noOptionsMessage={function() { return 'Nenhuma opção'; }}
              isDisabled={!!departamentoUsuario}
              isClearable={!departamentoUsuario}
            />
            {errors.departamento && <small className="text-danger">{errors.departamento}</small>}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Nome do Assunto <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Digite o nome do assunto"
              value={nomeAssunto}
              onChange={function(e) { setNomeAssunto(e.target.value); setErrors(function(prev) { var er = Object.assign({}, prev); delete er.nomeAssunto; return er; }); }}
              maxLength={100}
              isInvalid={!!errors.nomeAssunto}
            />
            {errors.nomeAssunto && <small className="text-danger">{errors.nomeAssunto}</small>}
            <Form.Text className="text-muted">
              {nomeAssunto.length}/100 caracteres
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={handleLimpar} className="mr-2" disabled={salvando}>
          Limpar
        </Button>
        <Button variant="primary" onClick={handleSalvar} disabled={salvando}>
          {salvando ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCadastroAssunto;
